<template>
  <RevPagination
    class="flex justify-center"
    :current-page
    :current-page-label="
      i18n(translations.page, {
        page: currentPage,
      })
    "
    :navigation-aria-label="i18n(translations.paginationLabel)"
    :next-aria-label="i18n(translations.paginationNextPage)"
    :page-aria-label="
      (page: number) =>
        i18n(translations.navigatePage, {
          page,
        })
    "
    :page-count
    :previous-aria-label="i18n(translations.paginationPreviousPage)"
  />
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevPagination } from '@ds/components/Pagination'

import translations from './Pagination.translations'

defineProps<{
  pageCount: number
  currentPage: number
}>()

const i18n = useI18n()
</script>
